import { API_URL } from "../../../config";
import { axios } from "../../../lib/axios";
import { API_ROUTES } from "../../../lib/constants";

export const getDocumentsData = (id: any): Promise<any> => {
	return axios.get(`${API_ROUTES.DOCUMENTS.VIEW_DOCUMENTS}/${id}`);
}


